module.exports = __webpack_public_path__ + "static/media/Facebook.f4c36e59.svg";